<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

@if(isNA) {
    <div class="not-applicable">{{'NOT_APPLICABLE' | translate}}</div>
}
@else {
    <div *ngIf="compliant; else notCompliant" class="compliant">{{'COMPLIANT' | translate}}</div>
    <ng-template #notCompliant>
        <div class="non-compliant">{{'NON_COMPLIANT' | translate}}</div>
    </ng-template>
}